import React from 'react'
import { DI } from 'modules'
import { Link } from 'components/link'
import Component from 'components/component'

export class HasPass extends Component {
  render() {
    const { strings } = this.props.common
    return (
      <section className="content">
        <div className="wrap wrap--high">
          <div className="payments-notification-container">
            <div className="payments-notification-inner">
              <span className="payments-notification__ico payments-notification__ico--success"></span>
              <span className="payments-notification__title">
                {strings['page.payment.summary.pass.decline.title']}
              </span>
              <div className="payments-notification__text">
                <p>
                  {strings['page.payment.summary.pass.decline.text_1']}
                  <Link to="/terms-of-use">
                    {strings['page.payment.summary.pass.decline.link']}
                  </Link>
                  {strings['page.payment.summary.pass.decline.text_2']}
                </p>
                <p>
                  <Link
                    className="button payments-notification__button"
                    to="/plans/request-subscription"
                  >
                    {
                      strings[
                        'page.payment.summary.pass.decline.request_enterprise'
                      ]
                    }
                  </Link>
                </p>
                <p>
                  <Link to="/plans">
                    {strings['page.payment.summary.pass.decline.back']}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default DI([])(HasPass)
